import { useState, useEffect, useCallback } from 'react';
import { offlineModeService } from 'utils/services';

// Returns the current offline-mode flag (source of truth: IDB, mirrored via
// BroadcastChannel). Use this when you need to know *just* whether the user
// has turned offline mode on — as opposed to useIsReadyAndOffline which is
// true only when offline mode AND local offline data is ready.
const useOfflineMode = () => {
  const [offlineMode, setOfflineMode] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const value = await offlineModeService.get();
      setOfflineMode(value);
    } catch (e) {
      setOfflineMode(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const unsubscribe = offlineModeService.subscribe((value) => setOfflineMode(value));
    return unsubscribe;
  }, [refresh]);

  return offlineMode;
};

export default useOfflineMode;
